<svelte:options tag="m-stars-input" />

<script lang="ts">
  import type { RatingsSize } from './ratings.types';

  const ratingValue = 5;
  export let unselectedText = 'No opinion given';
  export let name = 'rating';
  export let size: RatingsSize = 'm';
  export let ratinglabels: Array<string> = [
    'Very bad',
    'Bad',
    'Medium',
    'Good',
    'Excellent',
  ];

  function setClasses(size: RatingsSize): string {
    const mainClass = 'mc-stars-input';

    return size ? `${mainClass} ${mainClass}--${size}` : mainClass;
  }

  function setInputId(name: string, index: number): string {
    return `${name}${index + 1}`;
  }
</script>

<div class={setClasses(size)} {...$$restProps}>
  <input
    id="no-rate"
    type="radio"
    {name}
    value="0"
    class="mc-stars-input__radio"
    checked
    aria-label={unselectedText}
  />

  {#each Array(ratingValue) as _, i}
    <input
      id={setInputId(name, i)}
      type="radio"
      {name}
      value={i + 1}
      class="mc-stars-input__radio"
    />

    <label
      for={setInputId(name, i)}
      title={ratinglabels[i]}
      class="mc-stars-input__label"
    >
      <span class="mc-stars-input__text">
        {ratinglabels[i]}
      </span>
    </label>
  {/each}
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/_c.stars-input';
</style>
